export default class ResponseError extends Error {
  constructor(message = '', data = {}, ...args) {
    super(message, ...args)
    this.name = 'ResponseError'
    this.message = message
    this.data = data
  }
}
